import { compose } from 'redux';
import { createBannerReducer } from './createBanner';
import { deleteBannerReducer } from './deleteBanner';
import { fetchAllPromotionsReducer } from './fetchAllPromotions';
import { fetchCreationTabBannersReducer } from './fetchCreationTabBanners';
import { fetchVisualizationTabBannersReducer } from './fetchVisualizationTabBanners';
import { publishBannerListReducer } from './publishBannerList';
import { toggleBannerReducer } from './toggleBanner';
import { updateBannerReducer } from './updateBanner';

export const extraReducers = compose(
  fetchCreationTabBannersReducer,
  fetchVisualizationTabBannersReducer,
  createBannerReducer,
  updateBannerReducer,
  toggleBannerReducer,
  deleteBannerReducer,
  publishBannerListReducer,
  fetchAllPromotionsReducer,
);

export { createBanner } from './createBanner';
export { deleteBanner } from './deleteBanner';
export { fetchAllPromotions } from './fetchAllPromotions';
export { fetchCreationTabBanners } from './fetchCreationTabBanners';
export { fetchVisualizationTabBanners } from './fetchVisualizationTabBanners';
export { publishBannerList } from './publishBannerList';
export { toggleBanner } from './toggleBanner';
export { updateBanner } from './updateBanner';
